import { render, staticRenderFns } from "./user-group-role.vue?vue&type=template&id=33b32353&scoped=true&"
import script from "./user-group-role.vue?vue&type=script&lang=js&"
export * from "./user-group-role.vue?vue&type=script&lang=js&"
import style0 from "./user-group-role.vue?vue&type=style&index=0&id=33b32353&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b32353",
  null
  
)

export default component.exports